<template>
    <div
        id="supsis-right-modal"
        ref="supsisRightModal"
        :class="{ closed: closed, [type]: true }"
        :style="{ width, zIndex }"
        v-if="accessable"
    >
        <div class="action-buttons">
            <div class="btnWindow closeAction" @click="closeModal">
                <div class="material-icons">close</div>
            </div>
            <div
                class="btnWindow prevAction"
                :class="{ disabled: sliderOptions() && !sliderOptions().prevAvailable }"
                @click="() => (sliderOptions() && sliderOptions().prevAvailable ? sliderOptions().prev() : $_.noop())"
                v-if="sliderOptions()"
            >
                <div class="material-icons">arrow_back_ios</div>
            </div>
            <div
                class="btnWindow nextAction"
                :class="{ disabled: sliderOptions() && !sliderOptions().nextAvailable }"
                @click="() => (sliderOptions() && sliderOptions().nextAvailable ? sliderOptions().next() : $_.noop())"
                v-if="sliderOptions()"
            >
                <div class="material-icons">arrow_forward_ios</div>
            </div>
        </div>

        <div class="head">
            <div class="title" v-if="type === 'editor-task'" contenteditable="true" @input="updateTitle">
                {{ title }}
            </div>
            <div class="title" v-else>{{ title }}</div>
            <div class="description">{{ description }}</div>
        </div>
        <div class="content">
            <a-spin :spinning="loading">
                <CreateTaskForm
                    v-if="type === 'create-task'"
                    :window-type="'create-task'"
                    v-bind="payload || {}"
                    @update-form="updateForm"
                    :attachmentEditVisible="false"
                />
                <WorkflowForm v-if="type === 'create-workflow'" @update-form="updateForm" />
                <TaskSettings v-if="type === 'task-settings'" @update-form="updateForm" />
                <EditorTask
                    v-if="type === 'editor-task'"
                    :details="payload"
                    @update-form="updateForm"
                    @close-modal="closeModal"
                />
                <CreateTaskForm
                    v-if="type === 'edit-task'"
                    :window-type="'edit-task'"
                    v-bind="payload"
                    @update-form="updateForm"
                    :attachmentFileVisible="false"
                />
                <VisibilityWorkFlow
                    v-if="type === 'visibility-workflow'"
                    :details="payload"
                    @update-form="updateForm"
                />
                <PipelineStageForm v-if="type === 'pipeline-edit'" @update-form="updateForm" :details="payload" />
                <WorkflowForm v-if="type === 'edit-workflow'" @update-form="updateForm" :details="payload" />
                <VisitorDetail v-if="type === 'show-visitor'" :visitorId="payload.visitorId" />
                <CalendarSettings v-if="type === 'calendar-settings'" :payload="payload" />
            </a-spin>
        </div>
        <div class="footer" v-if="footer">
            <div class="classic-submit-button" @click="saveChanges(type)">{{ $t("wp.saveChanges") }}</div>
            <div class="classic-submit-button" type="normal" @click="closeModal">{{ $t("wp.cancel") }}</div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import CreateTaskForm from "../task/CreateTaskForm.vue";
import WorkflowForm from "../task/WorkflowForm.vue";
import TaskSettings from "../task/Settings/Settings.vue";
import EditorTask from "../task/Settings/EditorTask.vue";
import EditTask from "../task/Settings/EditTask.vue";
import PipelineStageForm from "../task/PipelineStageForm.vue";
import VisitorDetail from "../../views/Pages/Visitors/VisitorDetail.vue";
import CalendarSettings from "../../views/Pages/Calendar/CalendarSettings.vue";
import VisibilityWorkFlow from "../task/VisibilityWorkFlow.vue";
import { PERMISSION_TYPES } from "../../language/permissionTypes";

export default {
    name: "Window",
    components: {
        CreateTaskForm,
        WorkflowForm,
        TaskSettings,
        EditorTask,
        EditTask,
        PipelineStageForm,
        VisitorDetail,
        CalendarSettings,
        VisibilityWorkFlow,
    },
    props: {
        title: {
            type: String,
        },
        description: {
            type: String,
        },
        type: {
            required: true,
            type: String,
        },
        width: {
            required: true,
            type: String,
        },
        zIndex: {
            required: true,
            type: Number,
        },
        loading: {
            type: Boolean,
        },
        footer: {
            type: Boolean,
            default: true,
        },
        payload: {
            type: Object,
        },
        window: {
            type: Object,
        },
    },
    data: () => ({
        closed: false,
        form: {},
        listeners: [],
        accessable: true,
    }),
    computed: {
        ...mapState({
            windows: (state) => state.app.windows,
            user: (state) => state.auth.user,
            workflows: (state) =>
                state.tasks.workflows.reduce((acc, workflow) => {
                    acc[workflow._id] = workflow;
                    return acc;
                }, {}),
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
            createTask: "tasks/createTask",
            createWorkflow: "tasks/createWorkflow",
            updateTask: "tasks/updateTask",
            updateWorkflow: "tasks/updateWorkflow",
        }),
        sliderOptions() {
            console.log("sliderOptions", this.window.sliderOptions);
            return this.window.sliderOptions;
        },
        closeModal() {
            this.closed = true;
            setTimeout(() => this.$emit("close", this.type), 500);
        },
        updateForm(form) {
            this.form = form;
        },
        saveChanges(type) {
            if (type === "create-task") {
                this.createTask(this.form).then(() => {
                    this.$notification.success({
                        message: this.$t("task.taskCreatedMs"),
                        description: this.$t("task.taskCreatedMs"),
                    });
                });
            } else if (type === "create-workflow") {
                this.createWorkflow(this.form)
                    .then(() => {
                        this.$notification.success({
                            message: this.$t("task.workflowCreatedMs"),
                            description: this.$t("task.workflowCreatedMs"),
                        });
                    })
                    .catch(() => {
                        this.$notification.error({
                            message: this.$t("task.workflowCreateError"),
                            description: this.$t("task.workflowCreateError"),
                        });
                    });
            } else if (type === "editor-task") {
                this.updateTask({
                    taskId: this.payload.taskId,
                    params: {
                        ...this.form,
                    },
                }).then(() => {
                    this.$notification.success({
                        message: this.$t("task.taskUpdateMs"),
                        description: this.$t("task.taskUpdateMs"),
                    });
                });
            } else if (type === "edit-task") {
                this.updateTask({
                    taskId: this.payload.taskId,
                    params: {
                        ...this.form,
                    },
                }).then(() => {
                    this.$notification.success({
                        message: this.$t("task.taskUpdateMs"),
                        description: this.$t("task.taskUpdateMs"),
                    });
                });
            } else if (["visibility-workflow", "edit-workflow"].includes(type)) {
                this.updateWorkflow({
                    workflowId: this.payload.workflowId,
                    params: this.form,
                }).then(() => {
                    this.$notification.success({
                        message: this.$t("task.workflowUpdateMs"),
                        description: this.$t("task.workflowUpdateMs"),
                    });
                });
            }
            this.closeModal(type);
        },
        updateTitle(e) {
            this.form.title = e.target.innerText;
        },
    },
    mounted() {
        const fn = (e) => {
            if (e.key === "Escape") {
                const lastWindow = Object.keys(this.windows)[Object.keys(this.windows).length - 1];
                if (lastWindow === this.type) this.closeModal();
            }
        };

        const fn2 = (e) => {
            const dropdown = document.getElementsByClassName("ant-select-dropdown");
            const calendar = document.getElementsByClassName("ant-calendar-picker-container");
            const visitorDetail = document.getElementById("visitor-detail");
            const modal = this.$refs.supsisRightModal;

            if (
                visitorDetail.length === 0 &&
                dropdown.length === 0 &&
                calendar.length === 0 &&
                modal &&
                !modal.contains(e.target)
            ) {
                this.closeModal();
            }
        };
        console.log("this.payload...", this.payload);
        if (!this.payload?.isOpenClick) {
            setTimeout(() => {
                document.addEventListener("keydown", fn);
                document.addEventListener("click", fn2);
            }, 500);
        }
        this.listeners.push(() => {
            document.removeEventListener("keydown", fn);
            document.removeEventListener("click", fn2);
        });
    },
    created() {
        if (this.sliderOptions()) {
            const fn = (e) => {
                //if currenTarget is not input or textarea
                const isInput = e.target?.tagName === "INPUT" || e.target?.tagName === "TEXTAREA";
                if (!isInput) {
                    if (e.key === "ArrowRight" && this.sliderOptions().nextAvailable) {
                        this.sliderOptions().next();
                    } else if (e.key === "ArrowLeft" && this.sliderOptions().prevAvailable) {
                        this.sliderOptions().prev();
                    }
                }
            };
            document.addEventListener("keydown", fn);
            this.listeners.push(() => {
                document.removeEventListener("keydown", fn);
            });
        }
    },
    beforeDestroy() {
        this.listeners.forEach((fn) => fn());
    },
    beforeMount() {
        if (
            !this.checkPermission(PERMISSION_TYPES["task.create"].tr.name) &&
            (this.type === "create-task" || this.type === "create-workflow")
        ) {
            this.accessable = false;
            this.$message.error(this.$t("permissionErrors.taskCreate"));
        } else if (
            !this.checkPermission(PERMISSION_TYPES["task.update"].tr.name) &&
            (this.type === "task-settings" ||
                this.type === "pipeline-edit" ||
                this.type === "edit-workflow" ||
                this.type === "edit-task" ||
                this.type === "editor-task")
        ) {
            this.accessable = false;
            this.$message.error(this.$t("permissionErrors.taskUpdate"));
        }
    },
    watch: {
        "$route.path"() {
            this.closeModal();
        },
    },
};
</script>
<style lang="scss">
@keyframes openEffect {
    from {
        transform: translate3d(80vw, 0, 0);
    }
    to {
        transform: translate3d(0, 0, 0);
    }
}

#supsis-right-modal {
    position: fixed;
    right: 0;
    width: 80vw;
    height: calc(100vh);
    background-color: white;
    border-left: 1px solid #dddddd;
    animation-name: openEffect;
    animation-duration: 0.1s;
    transition: all 0.1s;
    -webkit-box-shadow: -26px 8px 65px -31px rgba(0, 0, 0, 0.39);
    -moz-box-shadow: -26px 8px 65px -31px rgba(0, 0, 0, 0.39);
    box-shadow: -26px 8px 65px -31px rgba(0, 0, 0, 0.39);

    &.closed {
        transform: translate3d(100vw, 0, 0);
    }

    &.show-visitor {
        .content {
            padding: 0;

            #visitor-detail {
                width: 100%;
                overflow: hidden;
                // --default-color: red;
            }
        }
    }

    .action-buttons {
        display: flex;
        flex-direction: column;
        position: absolute;
        left: -20px;
        top: 20px;
        z-index: 9999;
    }

    .btnWindow {
        background-color: white;
        border: 1px solid #dddddd;
        padding: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 20px;
        cursor: pointer;
        width: 30px;
        height: 30px;

        .material-icons {
            width: 14px;
            height: 14px;
            font-size: 17px;
            font-weight: bold;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        &.disabled {
            cursor: not-allowed;
            background-color: #dddddd;
        }
    }

    .head {
        border-bottom: 1px solid #dddddd;
        padding: 20px;
        padding-left: 30px;

        .title {
            font-weight: bold;
            font-size: 18px;
        }

        .description {
            font-size: 14px;
        }
    }

    .content {
        padding: 20px;
        padding-left: 45px;
        overflow: auto;
        height: calc(100% - 140px);
    }

    .footer {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 50px;
        box-shadow: 0 -7.5px 15px -7.5px rgba(0, 0, 0, 0.15);
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0px 20px;
        gap: 10px;
    }

    .classic-submit-button {
        background: #ec4b1d;
        color: white;
        padding: 8px 16px;
        border-radius: 4px;
        cursor: pointer;
        user-select: none;

        &:hover {
            background-color: #f76036;
        }

        &.disabled {
            background: #ec4b1d;
            cursor: not-allowed;
        }

        &[type="normal"] {
            background-color: white;
            border: 1px solid #5c5a56;
            color: #5c5a56;

            &:hover {
                background-color: #5c5a56;
                color: white;
            }
        }
    }
}
</style>
